import { IIdName } from '@/interfaces/general/IIdName.ts';
import { IChartSeriesAdditionalDetails, IChartModuleSeries } from '@/interfaces/powerMarkets/IModule.ts';
import { IModuleChartConfig } from '../charts/IModuleChartConfig.ts';
import { PlantOwnerOption } from '../IPlantOwners.ts';
import { ISeriesOption } from '../series/ISeriesOption.ts';

export interface ICustomSeries {
    seriesDbId: string;
    seriesUiId: string;
    chartSeries: IChartModuleSeries;
    additionalDetails?: IChartSeriesAdditionalDetails;
    uiDisplayDetails: {
        isPlant: boolean;
        optionsName: string | null;
        countryName: string | null;
        ogSeriesName: string;
        nameOverride?: boolean;
        nameSetByUser?: boolean;
    };
}
export interface IDashboardChartCreatorOptions {
    name: string;
    nameSetByUser?: boolean;
    id: string;
    selectedSeriesArray: Array<ICustomSeries>;
    axisStackType: string;
    axisSide: string;
    axisPositions: Array<{label: string; value: number; edited: boolean}> | null;
    axisLeftOrRight: Array<{label: string; value: 'left' | 'right'}>;
}

export enum CalculationTypes {
    num = 'num',
    operator = 'operator',
    decimalPoint = 'decimalPoint',
    parenthesis = 'parenthesis',
    series = 'series',
}

export interface ICalculationItem {
    value: string;
    seriesOption?: {
        series: ISeriesOption;
        seriesUiId: string;
        seriesDbId: string;
    };
    type: CalculationTypes;
}

export interface IPresetToEdit {
    config: IModuleChartConfig;
    country: IIdName;
    option: IIdName | null;
    isPlant: boolean;
    plantOwner: PlantOwnerOption;
}
